<div class="ui-project__header">
  <h5 class="font-weight-bold mb-0 mt-2">{{ 'ProjectSummary.email' | translate }}</h5>
</div>

<router-outlet />
